// extracted by mini-css-extract-plugin
module.exports = {"root":"InfralistChangeLogs_root__2bxzD"};